import React from 'react';
import BtnRadius from "../button/BtnRadius";
import {useMedia} from "react-use";

const CardFooter = (props) => {
    const isMobile = useMedia("(max-width: 992px)");
    const addRemove =  !isMobile ? <div className="px-4 pt-3 mx-2">
                        <div className={`d-flex flex-row ${props.isPlan ? 'justify-content-center': 'space-between'} pt-4 color-cod-gray inter-semi-bold font-medium`}>
                            <div className="small-btn"><span className="p-3">{props.isPlan ? 'Selected': 'Added'}</span></div>
                                { !props.isPlan ?
                                    <div><a onClick={props.handleRemove}>Remove</a></div> : ''
                                }
                            </div>
                        </div> :
                        <div className={`px-4 ${props.isPlan ? 'pt-5': 'pt-3'} mx-2`}>
                            <div className={`d-flex flex-row ${props.isPlan ? 'justify-content-center': 'space-between'} pt-4 color-cod-gray inter-semi-bold font-medium`}>
                                <div className="small-btn"><span className="p-3">{props.isPlan ? 'Selected': 'Added'}</span></div>
                                { !props.isPlan ?
                                    <div><a onClick={props.handleRemove}>Remove</a></div> : ''
                                }
                            </div>
                        </div>

    const button = <div className={`px-4 mx-5 ${isMobile ? 'pt-5':'pt-4'}`}>
                        {
                             <BtnRadius text ={props.isPlan ? 'Choose plan' :'Add to cart'} onClick={props.handleAdd}/>
                        }
                   </div>

    return (
        <section className={`card-footer ${!props.margin ? '': 'm-4'}`}>
            {props.content ? props.content: ''}
            <div className="card-footer-container">
                {
                    !props.active ? button : addRemove
                }
            </div>
        </section>
    );
}
export default CardFooter;


// WEBPACK FOOTER //
// ./resources/assets/js/flipToFibre/card/CardFooter.js